(() => {
  if (customElements.get('ssg-shipping-progress')) return;

  function moneyCents(value) {
    const numeric = value.replace(/[^0-9.,]/g, '');
    if (!numeric) return null;
    const decimal = numeric.match(/[.,](\d{2})$/);
    const whole = decimal ? numeric.slice(0, -3) : numeric;
    const cents = Number(whole.replace(/[.,]/g, '')) * 100 + (decimal ? Number(decimal[1]) : 0);
    return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
  }

  class ShippingProgress extends HTMLElement {
    connectedCallback() {
      this.cart = this.closest('[data-section-type="cart"]');
      if (!this.cart) return;
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.cart, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      const total = this.cart.querySelector('.Cart__Total [data-cart-total]');
      if (!total || getComputedStyle(total).visibility === 'hidden') {
        this.hidden = true;
        return;
      }
      const subtotal = moneyCents(total.textContent);
      const threshold = Number(this.dataset.threshold);
      if (subtotal === null || !Number.isSafeInteger(threshold) || threshold <= 0) {
        this.hidden = true;
        return;
      }
      const remaining = Math.max(0, threshold - subtotal);
      const amount = new Intl.NumberFormat(this.dataset.locale || 'en-CA', {
        style: 'currency', currency: this.dataset.currency || 'CAD'
      }).format(remaining / 100);
      const message = remaining === 0 ? this.dataset.qualified : this.dataset.remaining.replace('__SSG_AMOUNT__', amount);
      if (this.textContent !== message) this.textContent = message;
      this.hidden = false;
    }
  }

  customElements.define('ssg-shipping-progress', ShippingProgress);
})();
